export class UserInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get user() {
        return this.parent;
    }
    get isPremiumUser() {
        //if (this.user.id === 1) return false;
        return !!this.user.userData.premium;
    }
    get isGuestUser() {
        return this.user.userData.email.startsWith('gast');
    }
}
